// © 2001-2015 INOVx Solutions, Inc.
// 114 Pacifica Suite 300, Irvine, CA 92618 USA
// All rights reserved.
//
// This software is confidential, proprietary and unpublished property of
// INOVx Solutions, Inc.  It may NOT be copied in part or in whole on any
// medium, either electronic or printed, without the express written consent
// of INOVx Solutions, Inc.

import * as Interfaces from '../../Interfaces/Interfaces';
class HighlightEngine {
    private _meshManager: Interfaces.Interfaces.IMeshManager;

    constructor(meshManager: Interfaces.Interfaces.IMeshManager) {
        this._meshManager = meshManager;
    }

    dispose() {
        this._meshManager = null;
    }
}

export default HighlightEngine;